// react
import React, { useState, useEffect } from 'react';

// styles
import { Spacing } from '_styles';

// icons
import { PiNoteLight } from "react-icons/pi";

const CartCard = ({ item }) => {

    const [image, setImage] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [price, setPrice] = React.useState(0);
    const [quantity, setQuantity] = React.useState(0);
    const [comment, setComment] = React.useState('');
    const [totalPrice, setTotalPrice] = useState(0);

    useEffect(() => {
        // set each state
        if(item) {
            if(item?.image) setImage(item.image);
            if(item?.productTitle) setTitle(item.productTitle);
            if(item?.price) setPrice(item.price);
            if(item?.quantity) setQuantity(item.quantity);
            if(item?.comment) setComment(item.comment || '');
        }
    }, [item]);

    useEffect(() => {
        if(quantity && price) {
            setTotalPrice((quantity * price).toFixed(2));
        }
    }, [quantity, price])

    return (
        <div style={styles.wrapper}>

            {/* product image */}
            <div style={{ flex:1, display:'flex'}}>
                <img src={image} alt={title} style={styles.image} />
            </div>

            {/* product title, quantity, price, comment */}
            <div style={styles.textContainer}>
                <div style={styles.title}>{title}</div>
                <div style={styles.info}>
                    Qty: {quantity} &nbsp;|&nbsp; €{totalPrice}
                </div>

                {/* comment */}
                <div>
                    <p style={styles.info}><PiNoteLight size={18} color={'grey'} /> {comment}</p>
                </div>
            </div>
        </div>
    );
};

const styles = {
    wrapper: {
        flex:1,
        marginBottom: Spacing.SCALE_12,
        backgroundColor: '#fff',
        borderRadius: 10,
        //minHeight: Spacing.SCALE_100,
        padding:Spacing.SCALE_12,
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)',
    },
    image: {
        width: Spacing.SCALE_80,
        height: Spacing.SCALE_80,
        borderRadius: 6,
        objectFit: 'cover',
        marginRight: Spacing.SCALE_16,
    },
    textContainer: {
        flex: 2,
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        fontWeight: 'bold',
        fontSize: 16,
        color: '#333',
        marginBottom: Spacing.SCALE_4,
    },
    info: {
        fontSize: 14,
        color: '#666',
    },
};

export default CartCard;
